import { Layers, Headphones, Grid3x3, Snowflake, Droplet, Wrench, Shield } from 'lucide-react';
import { Building2, Users } from 'lucide-react';

// Tarjetas para categorías de productos
export const PRODUCT_CATEGORY_CARDS = [
  {
    icon: Layers,
    title: "Aislación Térmica para Construcción",
    description: "Soluciones de alta eficiencia como lana de vidrio, espumas de polietileno y mantas reflectivas que mejoran el confort térmico de viviendas y edificios.",
    path: "/catalog/thermal-insulation",
    highlight: false,
    imageUrl: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?q=80&w=2069&auto=format&fit=crop",
  },
  {
    icon: Headphones,
    title: "Insonorización Profesional",
    description: "Paneles acústicos, espumas fonoabsorbentes y materiales antivibratorios ideales para estudios de grabación, oficinas y auditorios.",
    path: "/catalog/soundproofing",
    highlight: false,
    imageUrl: "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?q=80&w=2070&auto=format&fit=crop",
  },
  {
    icon: Grid3x3,
    title: "Pisos y Membranas",
    description: "Productos como pisos vinílicos, alfombras modulares y membranas acústicas que brindan confort, estética y funcionalidad.",
    path: "/catalog/flooring",
    highlight: false,
    imageUrl: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?q=80&w=1974&auto=format&fit=crop",
  },
  {
    icon: Snowflake,
    title: "Aislación para Industria y Refrigeración",
    description: "Espumas elastoméricas, celda cerrada y productos especializados para cámaras frigoríficas, ductos y procesos industriales.",
    path: "/catalog/industrial-insulation",
    highlight: false,
    imageUrl: "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?q=80&w=2070&auto=format&fit=crop",
  },
  {
    icon: Droplet,
    title: "Selladores y Adhesivos Técnicos",
    description: "Espumas de poliuretano, siliconas y selladores específicos para asegurar instalaciones eficientes y duraderas.",
    path: "/catalog/sealants",
    highlight: false,
    imageUrl: "https://images.unsplash.com/photo-1617969791848-ec21a346cf4f?q=80&w=1974&auto=format&fit=crop",
  },
  {
    icon: Wrench,
    title: "Accesorios para Instalación",
    description: "Perfiles metálicos, tornillería, cintas, barreras de vapor y más, para una instalación profesional y segura de sistemas de aislación.",
    path: "/catalog/accessories",
    highlight: false,
    imageUrl: "https://images.unsplash.com/photo-1530124566582-a618bc2615dc?q=80&w=2070&auto=format&fit=crop",
  }
];

// Tarjetas CTA separadas
export const CTA_CARDS = [
  {
    icon: Building2,
    title: "Grandes Empresas",
    description: "Asesoramiento especializado y condiciones especiales para grandes volúmenes. Beneficios para Grandes Empresas, Atención especial para el sector público",
    benefitsTitle: "Velocidad, Atención Especial, Calidad, Confiabilidad",
    path: "/empresas",
    buttonText: "Solicitar asesoría",
    color: "amber",
    imageUrl: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop",
  },
  {
    icon: Users,
    title: "Distribuidores",
    description: "Unite a nuestra red de distribuidores y accedé a beneficios exclusivos. Amplia variedad y disponibilidad de productos. Nuestro stock crece constantemente en todas las industrias.",
    benefitsTitle: "Variedad, Entrega a domicilio, Retiro en local",
    path: "/register",
    buttonText: "Unirse a la red",
    color: "blue",
    imageUrl: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?q=80&w=2032&auto=format&fit=crop",
  },
  {
    icon: Shield,
    title: "Asesoramiento en Seguridad e Higiene",
    description: "Consultoría especializada en normativas de seguridad, evaluación de riesgos y implementación de programas de prevención para tu empresa",
    benefitsTitle: "Expertise, Cumplimiento Normativo, Prevención, Capacitación",
    path: "/asesoria-seguridad",
    buttonText: "Solicitar consultoría",
    color: "green",
    imageUrl: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=2070&auto=format&fit=crop",
  }
];


























